import lessonManager from '../managers/LessonManager';
import { Behavior } from './Behavior';
import { ContentType, LessonMode, QuestionFeedbackState } from '../../Constants';
import UtilsService from '../services/UtilsService';
import questionFeedbackManager from '../managers/QuestionFeedbackManager';


export class StandaloneAlchemieItemBehavior extends Behavior {
  mustMessageParent = () => {
    return false;
  }

  getMessage = (responseAnswer) => {
    return null;
  }

  checkForValidResponse = (responseAnswer) => {
    if (responseAnswer.goal === null || responseAnswer.goal.trim() === '' || responseAnswer.goal === undefined) {
      return false;
    }
    return true;
  }

  isAutoScored = (model) => {
    const autoScore = (ContentType.getAutoscore(model.type) &&
      !model.survey && !model.unscored);

    return autoScore;
  }

  setResponseData = (data, responseAnswer, model) => {
    responseAnswer.goal = (data)?data:'';
  }

  getInitializedResponse = (lessonElementId) => {
    const responseAnswer = {
      goal: '',
      lessonElementId,
      isCorrect: false
    };
    return responseAnswer;
  }

  getCorrectAnswersText = (model) => {
    return '<div></div>';
  }

  setCorrectAnswer = (state, model) => {
    const temp = {
      goal: model.validation.answers[0].goal,
      lessonElementId: model.lessonElementId,
      isCorrect:true
    };
    state.setCurrentResponse(UtilsService.safeMobxClone(temp));
  }

  resetStudentAnswer = (state) => {
    if (state && state.cachedResponseAnswer) {
      const model = lessonManager.getSlideModel(state.cachedResponseAnswer.lessonElementId);
      state.setCurrentResponse(UtilsService.safeMobxClone(state.cachedResponseAnswer));
    }
  }

  /// ///
  // model = content model
  //
  getQuestionFeedbackText = (model, correctFeedback, incorrectFeedback, correctFeedbackBody, incorrectFeedbackBody, mode, questionIsCorrect, currentAttemptCount, { lessonElementState }) => {
    let textBody = '';
    if (mode === LessonMode.PREVIEW || mode === LessonMode.ITEM_PREVIEW || mode === LessonMode.STUDENT_PREVIEW || mode === LessonMode.PUBLISHER_PREVIEW) {
      textBody += UtilsService.previewWarning();
    } else {
      if (typeof currentAttemptCount !== 'undefined' && currentAttemptCount !== -1 && currentAttemptCount > 1) {
        //textBody += UtilsService.saveWarning();
      } else {
        textBody += UtilsService.saveCommit();
      }
    }

    let textHeader = '';
    let attemptsText = '';
    
    // Add attempts remaining text for practice mode when answer is incorrect or partially correct
    if (questionFeedbackManager.isPractice && 
        (questionIsCorrect === QuestionFeedbackState.INCORRECT || questionIsCorrect === QuestionFeedbackState.PARTIAL_CORRECT) &&
        model.lessonElementId) {
      attemptsText = questionFeedbackManager.getAttemptsRemainingText(model.lessonElementId);
    }

    if (questionIsCorrect === QuestionFeedbackState.CORRECT) {
      textHeader = correctFeedback;
      if (correctFeedbackBody) {
        textBody = `${correctFeedbackBody} ${textBody}`;
      }
    } else if (questionIsCorrect === QuestionFeedbackState.PARTIAL_CORRECT) {
      textHeader = `${UtilsService.partiallyCorrect()}`;
      let custom = '';
      if (incorrectFeedbackBody) {
        custom = `${incorrectFeedbackBody } `;
      }

      textBody = `${UtilsService.partiallyCorrectPrompt()}. <br/>${ custom }${textBody}`;
    } else {
      textHeader = incorrectFeedback;
      if (incorrectFeedbackBody) {
        textBody = `${incorrectFeedbackBody} ${textBody}`;
      }
    }

    // Add attempts text after the header if it exists
    if (attemptsText) {
      textHeader += attemptsText;
    }

    let finalText = '<div class=\'question-feedback-header\'>';
    finalText += textHeader;
    finalText += '</div>';
    finalText += '<div class=\'question-feedback-body\'>';
    finalText += textBody;
    finalText += '</div>';

    return finalText;
  }

  isAnswerCorrect = (answerId, lessonElementState, model) => {
    if (lessonElementState.correctAnswerShowing) {
      return true;
    }

    return lessonElementState.isScored && (lessonElementState.submittedItemScore === lessonElementState.maxScore);
  }

  isQuestionCorrect = (lessonElementState, lessonElementId) => {
    if (!lessonElementState) {
      return QuestionFeedbackState.INCORRECT;
    }

    if (lessonElementState.submittedItemScore >= lessonElementState.maxScore) {
      return QuestionFeedbackState.CORRECT;
    }
    if ((lessonElementState.submittedItemScore > 0) && (lessonElementState.submittedItemScore < lessonElementState.maxScore)) {
      return QuestionFeedbackState.PARTIAL_CORRECT;
    }

    return QuestionFeedbackState.INCORRECT;
  }

} 

export default new StandaloneAlchemieItemBehavior();